export default __webpack_public_path__ + "static/article-digital-is-the-new-cash-a5a115ae6cdaa59373723f387c65036d.jpg";